import * as CONSTANTS from './constants'
import { ActionLogger } from './ActionLogger';

/**
 * DirectedAttack class handles the logic for backtracking and determining if a directed attack has reached a dead end
 */
export class DirectedAttack {
    /** the lead node is the node at the front of the attack trail */
    attackTrail;
    /** all nodes that have been backtracked through */
    backTrackedNodes;
    startingNode;

    constructor() {}

    /**
     * build new directed attack at starting leadNode and populate backTrackedNodes, attackTrail, and startingNode accordingly
     * @param {string} leadNode 
     * @return {DirectedAttack} instance
     */
    static build(leadNode) {
        let instance = new DirectedAttack();
        instance.attackTrail = [leadNode];
        instance.startingNode = leadNode;
        instance.backTrackedNodes = [];
        return instance;
    }

    /**
     * @param {Storage} storage is necessary so that we can check if a node is still infected. If not, then we need to backtrack.
     * @return {string} node.name that will launch the next attack
     */
    getAttackingNode(storage) {
        if (storage.getNodeData(this.attackTrail[0]).getStatus() !== CONSTANTS.INFECTED_DIRECTED) {
            if (!this.backtrack()) return null;
            return this.getAttackingNode(storage);
        }
        return this.attackTrail[0];
    }

    /** If the attacking node has no options, this function can be called to force the attack trail to backtrack
     * @return {bool} success: if it hits a dead end, this will return false
     */
    backtrack() {
        let logger = ActionLogger.getLogger();
        if (this.attackTrail.length === 1) {
            logger.log('Directed attack from ' + this.startingNode + ' hit a dead end at ' + this.attackTrail[0]);
            return false;
        }
        this.backTrackedNodes.unshift(this.attackTrail.pop());
        logger.log('Directed attack from ' + this.startingNode + ' backtracked from ' + this.backTrackedNodes[0] + ' to ' + this.attackTrail[0]);
        return true;
    }

    /**
     * Advance trail so that the head is at the newly infected node
     * @param {string} infectedNode
     */
    advanceTrail(infectedNode) {
        this.attackTrail.unshift(infectedNode);
    }

    toJSON() {
        return {
            attack_trail: this.attackTrail,
            back_tracked_nodes: this.backTrackedNodes,
            starting_node: this.startingNode
        };
    }

    static jsonDeserialize(jsonString) {
        let data = jsonString;
        let instance = new DirectedAttack();
        instance.attackTrail = data.attack_trail;
        instance.backTrackedNodes = data.back_tracked_nodes;
        instance.startingNode = data.starting_node;
        return instance;
    }

}